import { createFileRoute } from "@tanstack/react-router";
import { requireRole } from "@/auth/requireRole.ts";
import { ROLE_ADMIN } from "@/constants";
import { Button, CardContent, CardHeader, Grid } from "@mui/material";
import AppCard from "@/components/AppCard.tsx";

import { PermissionGuard } from "@/auth/PermissionGuard.tsx";

export const Route = createFileRoute("/_dashboard/showcase/admin-page")({
  beforeLoad: (args) => {
    console.log("quoi");
    requireRole([ROLE_ADMIN])(args);
  },
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Grid container spacing={6}>
      <Grid size={{ xs: 12 }}>
        <AppCard>
          <CardHeader title={`Page admin uniquement`} />
          <CardContent>
            <PermissionGuard admin>
              <Button variant="contained">Bouton admin</Button>
            </PermissionGuard>
          </CardContent>
        </AppCard>
      </Grid>
    </Grid>
  );
}
